<template>
    <van-row>
        <br>
        <van-image width="100%" src="https://files.aqsctzzy.com/common/logo-header.png"/>
        <br>
        <van-row v-show="''==category.name && 'success'!=step">
            <van-row style="text-align: center;color: #f0e0de;">
                ——<span style="color: #62bcc7;font-size: 1.5em;margin: auto 10px">在线报名</span>——
            </van-row>
            <van-row style="margin: 20px 30px;" v-for="(cate,cate_index) in categories" :key="cate_index">
                <van-cell :style="categoriesItemClass(cate_index)" @click="chooseParentCategory(cate_index)">
                    <template #icon>
                        <van-icon name="apps-o"/>
                    </template>
                    <template #title>
                        <span style="margin-left: 5px">{{ cate.name }}</span>
                    </template>
                    <template #right-icon>
                        <van-icon name="arrow"/>
                    </template>
                </van-cell>
            </van-row>
            <van-divider/>
            <van-row style="margin: 20px 30px;">
                <van-row style="text-align: center;color: #f0e0de;">
                    ——<span style="color: #62bcc7;font-size: 1.5em;margin: auto 10px">在线学习</span>——
                </van-row>
                <br>
                <a href="https://peixun.schcpx.com/m/#/">在线练题(点击进入)</a>
            </van-row>

            <van-row style="margin: 20px 30px;">
                <van-row style="text-align: center;color: #f0e0de;">
                    ——<span style="color: #62bcc7;font-size: 1.5em;margin: auto 10px">联系我们</span>——
                </van-row>
                <br>
                黄老师:15983190723<br>
                陈老师:13990064350
            </van-row>
        </van-row>


        <br>

        <van-row v-show="''!=category.name && 'success'!=step">
            <van-row type="flex" justify="space-between">
                <van-col style="margin: auto 10px">
                    <van-icon size="18" color="#ed724e" name="play-circle"/>
                    <span style="color:#bfbfbf;margin: auto 5px;font-size: 1.2em">在线报名:</span>
                </van-col>
                <van-col style="margin-right: 10px">
                    <van-button type="info" hairline size="mini" @click="category.name=''">返回</van-button>
                </van-col>
            </van-row>

            <van-row style="text-align: center;color: #f0e0de;margin: 20px auto">
                <span style="color: #62bcc7;font-size: 1.5em;margin: auto 10px">{{ this.category.name }}</span>
            </van-row>


            <van-row style="margin: auto 10px">
                <van-form label-width="5em" :colon="true" @submit="onSubmit">
                    <van-field
                            readonly
                            clickable
                            :required="true"
                            name="category_name"
                            :value="item.category_name"
                            label="报名科目"
                            placeholder="点击选择报名科目"
                            @click="showCategoryPicker = true"
                    />
                    <van-popup v-model="showCategoryPicker" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="category.children"
                                @confirm="categoryOnConfirm"
                                @cancel="showCategoryPicker = false"
                        />
                    </van-popup>

                    <van-field
                            v-model="item.name"
                            :required="true"
                            name="name"
                            label="姓名"
                            placeholder="姓名"
                            :rules="[{ required: true, message: '请填写姓名' }]"
                    />
                    <van-field :required="true" name="sex" label="性别">
                        <template #input>
                            <van-radio-group v-model="item.sex" direction="horizontal">
                                <van-radio name="男">男</van-radio>
                                <van-radio name="女">女</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                    <van-field
                            v-model="item.id_card"
                            :required="true"
                            name="id_card"
                            label="身份证"
                            placeholder="身份证"
                            :rules="[{ required: true, message: '请填写身份证' }]"
                    />
                    <van-field
                            v-model="item.phone"
                            rel="tel"
                            :required="true"
                            name="phone"
                            label="手机号"
                            placeholder="手机号"
                            :rules="[{ required: true, message: '请填写手机号' }]"
                    />
                    <van-field
                            readonly
                            clickable
                            :required="true"
                            name="qualifications"
                            :value="item.qualifications"
                            label="学历"
                            placeholder="点击选择学历"
                            @click="showQualificationsPicker = true"
                    />
                    <van-popup v-model="showQualificationsPicker" position="bottom">
                        <van-picker
                                show-toolbar
                                :columns="['初中','中专','高中','专科','本科','研究生及以上']"
                                @confirm="qualificationsOnConfirm"
                                @cancel="showQualificationsPicker = false"
                        />
                    </van-popup>

                    <van-field
                        readonly
                        clickable
                        :required="true"
                        name="ethnicity"
                        :value="item.ethnicity"
                        label="民族"
                        placeholder="点击选择民族"
                        @click="showPickerEthnicity = true"
                    />
                    <van-popup v-model="showPickerEthnicity" position="bottom">
                        <van-picker
                            show-toolbar
                            :columns="['汉族','彝族','回族','藏族','维吾尔族','苗族','蒙古族','壮族','布依族','朝鲜族','满族',
                            '侗族','瑶族','白族','土家族','哈尼族','哈萨克族','傣族','黎族','傈僳族','佤族','畲族','高山族',
                            '拉祜族','水族','东乡族','纳西族','景颇族','柯尔克孜族','土族','达斡尔族','仫佬族','羌族',
                            '布朗族','撒拉族','毛南族','仡佬族','锡伯族','阿昌族','普米族','塔吉克族','怒族','乌孜别克族',
                            '俄罗斯族','鄂温克族','德昂族','保安族','裕固族','京族','塔塔尔族','独龙族','鄂伦春族','赫哲族',
                            '门巴族','珞巴族','基诺族']"
                            @confirm="ethnicityOnConfirm"
                            @cancel="showPickerEthnicity = false"
                        />
                    </van-popup>

                    <van-field
                        readonly
                        clickable
                        v-model="item.birth_date"
                        name="birth_date"
                        label="出生年月"
                        placeholder="请选择出生年月"
                        @click="showPickerBirthDate = true"
                    />
                    <van-popup v-model="showPickerBirthDate" position="bottom">
                        <van-datetime-picker
                            type="date"
                            @confirm="onConfirmBirthDate"
                            :min-date="new Date(1949, 0, 1)"
                            :max-date="new Date(2004, 0, 1)"
                            @cancel="showPickerBirthDate = false"/>
                    </van-popup>


                    <van-field
                        v-model="item.home_address"
                        name="home_address"
                        :required="false"
                        label="家庭住址"
                        placeholder="请输入家庭住址"
                        type="textarea"
                        rows="3"
                        autosize
                        :rules="[{ required: false, message: '请输入家庭住址' }]"
                    />
                    <van-field
                        v-model="item.health_status"
                        name="health_status"
                        :required="false"
                        label="健康状况"
                        placeholder="请输入健康状况"
                        :rules="[{ required: false, message: '请输入健康状况' }]"
                    />

                    <van-field
                            v-model="item.organ_name"
                            name="organ_name"
                            :required="true"
                            label="单位名称"
                            placeholder="无单位填写个体"
                            :rules="[{ required: true, message: '请填写单位名称,无单位填写个体' }]"
                    />
                    <van-field
                            v-model="item.organ_address"
                            name="organ_address"
                            :required="false"
                            label="单位地址"
                            placeholder="请填写单位地址"
                            :rules="[{ required: false, message: '请填写单位地址' }]"
                    />
                    <van-field
                            v-model="item.position"
                            name="position"
                            :required="false"
                            label="职务"
                            placeholder="请输入职务"
                            :rules="[{ required: false, message: '请输入职务' }]"
                    />

                    <van-field
                        readonly
                        clickable
                        v-model="item.term_office"
                        name="term_office"
                        label="任现职时间"
                        placeholder="请选择任现职时间"
                        @click="showPickerTermOffice = true"
                    />
                    <van-popup v-model="showPickerTermOffice" position="bottom">
                        <van-datetime-picker
                            type="date"
                            @confirm="onConfirmTermOffice"
                            :min-date="new Date(1949, 0, 1)"
                            :max-date="new Date()"
                            @cancel="showPickerTermOffice = false"/>
                    </van-popup>
                    <van-field :required="false" name="type" label="人员类型">
                        <template #input>
                            <van-radio-group v-model="item.personnel_type" direction="horizontal">
                                <van-radio name="主要负责人">主要负责人</van-radio>
                                <van-radio name="安全生产管理人员">安全生产管理人员</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>





                    <van-field
                            v-model="item.work_experience"
                            name="work_experience"
                            :required="false"
                            label="工作简历"
                            placeholder="请输入工作简历"
                            type="textarea"
                            rows="3"
                            autosize
                            :rules="[{ required: false, message: '请输入工作简历' }]"/>

                    <van-field :required="true" name="type" label="取证类型">
                        <template #input>
                            <van-radio-group v-model="item.type" direction="horizontal">
                                <van-radio name="新训">新训</van-radio>
                                <van-radio name="复审">复审</van-radio>
                                <van-radio name="换证">换证</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>

                    <van-field :required="true" name="file_id_card_front" label="身份证正面(头像)">
                        <template #input>
                            <van-uploader name="id_card_front" v-model="file_id_card_front" :max-count="1"
                                          :after-read="afterRead"/>
                        </template>
                    </van-field>

                    <van-field :required="true" name="file_id_card_back" label="身份证反面(国徽)">
                        <template #input>
                            <van-uploader name="id_card_back" v-model="file_id_card_back" :max-count="1"
                                          :after-read="afterRead"/>
                        </template>
                    </van-field>


                    <van-field :required="true" name="file_id_card_avatar" label="证件照">
                        <template #input>
                            <van-uploader name="id_card_avatar" v-model="file_id_card_avatar" :max-count="1"
                                          :after-read="afterRead"/>
                        </template>
                    </van-field>


                    <van-field name="file_education_materials" label="学历证照">
                        <template #input>
                            <van-uploader name="education_materials" v-model="file_education_materials" :max-count="1"
                                          :after-read="afterRead"/>
                        </template>
                    </van-field>


                    <div style="margin: 16px;">
                        <van-button round block type="info" native-type="submit">
                            立即报名
                        </van-button>
                    </div>
                </van-form>
            </van-row>
        </van-row>


        <van-row v-show="'success'==step">
            <van-row style="text-align: center">
                <van-icon name="passed" size="150" color="green"/>
                <p style="font-size: 1.5em">报 名 成 功</p>
            </van-row>
        </van-row>

        <van-overlay :show="loading" style="display: flex;align-items: center;justify-content: center;height: 100%;">
            <van-loading size="24px" vertical>报名中...</van-loading>
        </van-overlay>

    </van-row>
</template>

<script>
export default {
    data() {
        return {
            step: "",
            loading: false,
            showCategoryPicker: false,
            showQualificationsPicker: false,
            categories: [],

            showPickerBirthDate: false,
            showPickerTermOffice: false,
            showPickerEthnicity: false,

            category: {
                index: "",
                name: "",
                children: ""
            },

            file_id_card_avatar: [],
            file_id_card_front: [],
            file_id_card_back: [],
            file_education_materials: [],


            item: {
                name: "",
                sex: "",
                id_card: "",
                phone: "",
                qualifications: "",
                organ_name: "",
                type: "",
                category_name: "",
                id_card_avatar: "",
                id_card_front: "",
                id_card_back: "",
                education_materials: "",

                term_office: "",
                organ_address: "",
                position: "",
                ethnicity: "",
                birth_date: "",
                home_address: "",
                health_status: "",
                personnel_type: "",
                work_experience: "",
            }
        };
    },
    created() {
        this.getCategories()
    },
    methods: {
        onConfirmBirthDate(time) {
            this.item.birth_date = this.$moment(time).format("YYYY-MM-DD")
            this.showPickerBirthDate = false
        },
        onConfirmTermOffice(time) {
            this.item.term_office = this.$moment(time).format("YYYY-MM-DD")
            this.showPickerTermOffice = false
        },
        ethnicityOnConfirm(value){
            this.item.ethnicity=value
            this.showPickerEthnicity=false
        },
        getCategories() {
            this.$http.get("/wechat/register/categories").then(res => {
                if (200 === res.data.code) {
                    this.categories = res.data.data
                }
            });
        },
        chooseParentCategory(cate_index) {
            this.category.name = this.categories[cate_index].name
            this.category.children = this.categories[cate_index].children
        },
        categoryOnConfirm(value) {
            this.showCategoryPicker = false
            this.item.category_name = value
        },
        qualificationsOnConfirm(value) {
            this.showQualificationsPicker = false
            this.item.qualifications = value
        },
        dataURLtoFile(dataurl, filename) {
            let arr = dataurl.split(',');
            let mime = arr[0].match(/:(.*?);/)[1];
            let bstr = atob(arr[1]);
            let n = bstr.length;
            let u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], filename, {type: mime});
        },
        afterRead(file, source) {
            console.log(source)

            file.status = 'uploading';
            file.message = '上传中...';

            let fileSize = parseFloat(parseInt(file.file['size']) / 1024 / 1024).toFixed(2);
            const img = new Image();
            img.src = file.content; // 指定图片的DataURL(图片的base64编码数据)
            img.onload = () => {
                const canvas = document.createElement('canvas'); // 创建Canvas对象(画布)
                const context = canvas.getContext('2d');
                //默认按比例压缩
                let cw = img.width;
                let ch = img.height;
                let w = img.width;
                let h = img.height;
                canvas.width = w;
                canvas.height = h;
                if (cw > 500 && cw > ch) {
                    w = 500;
                    h = (500 * ch) / cw;
                    canvas.width = w;
                    canvas.height = h;
                }
                if (ch > 500 && ch > cw) {
                    h = 500;
                    w = (500 * cw) / ch;
                    canvas.width = w;
                    canvas.height = h;
                }
                //生成canvas
                let base64;
                // 创建属性节点
                context.clearRect(0, 0, 0, w, h);
                context.drawImage(img, 0, 0, w, h);

                const formData = new FormData()
                if (fileSize > 2) {
                    //如果图片超过2m,则进行压缩
                    base64 = canvas.toDataURL(file.file['type'], 0.94);
                    formData.append('file', this.dataURLtoFile(base64, file.file.name))
                } else {
                    formData.append('file', file.file)
                }

                this.$http.post("/backend/common/upload", formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    onUploadProgress: progressEvent => {
                        console.log('上传进度：', Math.round((progressEvent.loaded / progressEvent.total) * 100))
                    }
                }).then(res => {
                    console.log('上传成功：', res.data.data.url)
                    file.status = "done"
                    file.message = "上传成功"

                    switch (source.name) {
                        case "id_card_avatar":
                            this.item.id_card_avatar = res.data.data.path
                            break;
                        case "id_card_front":
                            this.item.id_card_front = res.data.data.path
                            break;
                        case "id_card_back":
                            this.item.id_card_back = res.data.data.path
                            break;
                        case "education_materials":
                            this.item.education_materials = res.data.data.path
                            break;
                    }
                }).catch(err => {
                    file.status = 'failed';
                    file.message = '上传失败';
                    console.error('上传失败：', err)
                })
            };

        },

        onSubmit() {
            if (this.item.id_card_avatar.length <= 0) {
                this.$dialog.alert({title: '报名失败', message: "请上传证件照"})
                return
            }
            if (this.item.id_card_front.length <= 0) {
                this.$dialog.alert({title: '报名失败', message: "请上传身份证正面"})
                return
            }
            if (this.item.id_card_back.length <= 0) {
                this.$dialog.alert({title: '报名失败', message: "请上传身份证反面"})
                return
            }
            if (this.item.type === "新训" && this.item.education_materials.length <= 0) {
                this.$dialog.alert({title: '报名失败', message: "请上传学历材料"})
                return
            }
            this.loading = true
            this.item.category_name = this.category.name + "-" + this.item.category_name;

            this.$http.post("/wechat/register", this.item).then(res => {
                this.loading = false
                console.log(res.data);
                if (200 !== res.data.code) {
                    this.$toast.fail(res.data.msg);
                } else {
                    this.step = "success";
                }
            });

        },

        categoriesItemClass(key) {
            var colors = ["#668dc1", "#cf934b", "#5ba169", "#b96288", "#96a45f"]

            if ((key + 1) > colors.length) {
                key = key - colors.length
            }

            return {
                background: colors[key],
                "border-radius": "10px",
                "color": "white",
            };
        }
    },
}
</script>
